import React from 'react';
import PropTypes from 'prop-types';
import {Image, Conseil, ConseilItemTitle, Title, Description} from './styles';

// Le lien vers la page du conseil s'ouvre dans l'écran interne (SiteLinkInterceptor).
const ConseilItem = ({title, content, image, link}) => (
  <Conseil href={link}>
    <Image src={image} />
    <ConseilItemTitle>
      <Title
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: title,
        }}
      />
      <Description
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
    </ConseilItemTitle>
  </Conseil>
);

ConseilItem.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string.isRequired,
};

export default ConseilItem;
